import * as React from 'react';
import classnames from 'classnames';
import EditorText from '../../../../../common/richTextField/EditorText';
import { Question, MULTIMEDIA_TYPES } from '@nexxt/common/types';
import BubbleDragContainer from '../BubbleDragContainer';

interface RichTextBubbleProps {
    question: Question;
    index: number; // for sortableElement
    content: any;
    langName: string;
    defaultText?: string;
    disableAddBubble?: boolean;
    settings?: {
        showTextarea?: boolean;
        noBorder?: boolean;
        isHTMLText?: boolean;
        showRootReference?: boolean;
        showDynamicReference?: boolean;
        showClose?: boolean;
    };
    disabled: boolean;
    setValue: (value: any, index: number) => void;
    addNewBubble: (type: MULTIMEDIA_TYPES, data?) => void;
    removeBubble: (languageCode: string, index: number) => void;
}

const RichTextBubble: React.FC<RichTextBubbleProps> = ({
    question,
    content,
    langName,
    index,
    defaultText,
    disableAddBubble,
    settings,
    disabled,
    setValue,
    addNewBubble,
    removeBubble
}: RichTextBubbleProps) => {
    return (
        <BubbleDragContainer
            index={index}
            disableAddBubble={disableAddBubble}
            disableState={disabled}
        >
            <EditorText
                question={question}
                index={index}
                langName={langName}
                richTextTranslationChange={setValue}
                disabled={disabled}
                value={content?.richText}
                removeEditor={(index) => removeBubble(langName, index)}
                addNewBubble={addNewBubble}
                isHTMLText={settings?.isHTMLText}
                showDynamicReference={settings?.showDynamicReference}
                showRootReference={settings?.showRootReference}
                defaultText={defaultText}
                disableAddBubble={disableAddBubble}
                showClose={settings?.showClose}
            />
        </BubbleDragContainer>
    );
};

export default RichTextBubble;
